import {fetchApi} from "@/lib/fetch/fetchApi";
import {configurationType, userType} from "@/lib/definitions/definitions";

export function getTemplates(configuration: configurationType, securityToken: string|null) {

    return fetchApi({
        route: 'email_templates',
        type: "GET",
        configuration: configuration,
        securityToken: securityToken
    })

}